import type { VFC } from 'react'
import { Icon } from '@opallabs/kuiper'
import type { WithTheme } from '@opallabs/lapidary'
import * as styles from './styles'

type EmptyStateProps = Readonly<
  WithTheme & {
    icon: string
    text: string
  }
>

export const EmptyState: VFC<EmptyStateProps> = ({
  icon,
  text,
  theme = 'light',
}) => (
  <div css={styles.emptyPanel({ theme })}>
    <Icon
      glyph={icon}
      height={50}
      style={{ marginBottom: '20px' }}
      system={icon.includes('gem') ? 'gem' : 'hypernova'}
      width={50}
      ariaMode="hidden"
    />
    <p>{text}</p>
  </div>
)
